import { render, staticRenderFns } from "./configuration-automation-personnel-algorithms-definition-modal-basic-form.vue?vue&type=template&id=56a6f3fc&scoped=true&"
import script from "./configuration-automation-personnel-algorithms-definition-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-personnel-algorithms-definition-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-personnel-algorithms-definition-modal-basic-form.scss?vue&type=style&index=0&id=56a6f3fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6f3fc",
  null
  
)

export default component.exports